import { all } from "redux-saga/effects"
import authSaga from "../layouts/Auth/redux/sagas";
import addressSaga from "../layouts/Admin/Address/redux/sagas";
import homeSaga from "../layouts/Admin/Home/redux/sagas";
import adminSetupSaga from "../layouts/Admin/Setup/redux/sagas";
import salesManagementSaga from "../layouts/Sales/Management/redux/sagas";
import salesTransactionsSaga from "../layouts/Sales/Transactions/redux/sagas";
import purchaseTransactionsSaga from "../layouts/Purchase/Transactions/redux/sagas";
import salesSettlementSaga from "../layouts/Sales/ReportAndEnquiry/redux/sagas";
import purchaseSettlementSaga from "../layouts/Purchase/ReportAndEnquiry/redux/sagas";
import purchaseManagementSaga from "../layouts/Purchase/Management/redux/sagas";
import salesSetupSaga from "../layouts/Sales/Setup/redux/sagas";
import purchasesetupSaga from "../layouts/Purchase/Setup/redux/sagas";
import productSetupSaga from "../layouts/Product/Setup/redux/sagas";
import productProductSaga from "../layouts/Product/Product/redux/sagas";
import crudSaga from "../layouts/CRUD/redux/sagas";
import uploadSaga from "../layouts/Upload/redux/sagas";

import commonSaga from "../layouts/Dashboard/redux/sagas";
import salesDashboardSaga from "../layouts/Sales/Dashboard/redux/sagas";
import productDashboardSaga from "../layouts/Product/Dashboard/redux/sagas";
import purchaseDashboardSaga from "../layouts/Purchase/Dashboard/redux/sagas";
import adminDashboardSaga from "../layouts/Admin/Dashboard/redux/sagas";
import younoteAdminDashboardSaga from "../layouts/YounoteAdmin/Dashboard/redux/sagas";
import adminReportSaga from "../layouts/Admin/ReportAndEnquiry/redux/sagas";
import younoteAdminSecuritySetupSaga from "../layouts/YounoteAdmin/SecuritySetup/redux/sagas";
import younoteAdminProductSaga from "../layouts/YounoteAdmin/Product/redux/sagas";
import younoteAdminSetupSaga from "../layouts/YounoteAdmin/Setup/redux/sagas";
import instanceSaga from "../layouts/Admin/BatchProcess/redux/sagas";

export default function* rootSaga() {
    yield all([
        authSaga(),
        addressSaga(),
        homeSaga(),
        adminSetupSaga(),
        adminReportSaga(),
        salesSetupSaga(),
        purchasesetupSaga(),
        crudSaga(),
        uploadSaga(),
        productSetupSaga(),
        productProductSaga(),
        salesManagementSaga(),
        purchaseManagementSaga(),
        salesTransactionsSaga(),
        purchaseTransactionsSaga(),
        salesSettlementSaga(),
        purchaseSettlementSaga(),
        younoteAdminSecuritySetupSaga(),
        younoteAdminProductSaga(),
        salesDashboardSaga(),
        purchaseDashboardSaga(),
        adminDashboardSaga(),
        younoteAdminDashboardSaga(),
        productDashboardSaga(),
        younoteAdminSetupSaga(),
        commonSaga(),
        instanceSaga()
    ]);
}